/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSON(json) {
    return CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSONTyped(json, false);
}
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        clientSecret: json['client_secret']
    };
}
export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        client_secret: value.clientSecret
    };
}
